import { render } from "./SizesListing.vue?vue&type=template&id=5436b36e&ts=true"
import script from "./SizesListing.vue?vue&type=script&lang=ts"
export * from "./SizesListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__